import './reference-files.scss';
import React from 'react';
import { T } from 'shared/helper/translate';
import Files from './Files';
var ReferenceFiles = function ReferenceFiles(_ref) {
  var allowAnonymousUploads = _ref.allowAnonymousUploads,
    apiRoot = _ref.apiRoot,
    methods = _ref.methods,
    name = _ref.name,
    type = _ref.type,
    includeReferenceFiles = _ref.includeReferenceFiles,
    onReferenceInquiryUpdated = _ref.onReferenceInquiryUpdated;
  return /*#__PURE__*/React.createElement("div", {
    className: "reference-files"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3 control-group"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "reference-files"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Do you have any other files for our reference?"
  })), /*#__PURE__*/React.createElement("div", {
    className: "controls"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-check-inline"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    value: "1",
    onChange: function onChange() {
      return onReferenceInquiryUpdated(true);
    },
    checked: includeReferenceFiles || false
  }), /*#__PURE__*/React.createElement(T, {
    source: "Yes"
  })), /*#__PURE__*/React.createElement("label", {
    className: "form-check-inline"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    value: "1",
    onChange: function onChange() {
      return onReferenceInquiryUpdated(false);
    },
    checked: !includeReferenceFiles
  }), /*#__PURE__*/React.createElement(T, {
    source: "No"
  })))), includeReferenceFiles ? /*#__PURE__*/React.createElement(Files, {
    apiRoot: apiRoot,
    methods: methods,
    type: type,
    name: name,
    allowAnonymousUploads: allowAnonymousUploads
  }) : null);
};
export default ReferenceFiles;